import { baseDate, baseDateValues, monthNames} from "./settings"

class CustomDate {
	constructor(year, month, day, isBC = false) {
		// Parametrelerin geçerli olup olmadığını kontrol et
		if (
			year === undefined ||
			year === null ||
			month === undefined ||
			month === null ||
			day === undefined ||
			day === null
		) {
			console.error("CustomDate: Invalid parameters", {
				year,
				month,
				day,
				isBC
			})
			// Hatalı değerler yerine varsayılan tarih kullan
			year = baseDateValues.year
			month = baseDateValues.month
			day = baseDateValues.day
			isBC = false
		}

		// Sayısal olmayan değerleri zorla sayıya çevir
		year = Number(year)
		month = Number(month)
		day = Number(day)

		// Geçersiz sayılar varsa düzelt
		if (isNaN(year)) year = baseDateValues.year
		if (isNaN(month)) month = baseDateValues.month
		if (isNaN(day)) day = baseDateValues.day

		// Handle BC dates by making the year negative
		if (isBC && year > 0) {
			year = -year;
		}

		this.date = new Date(baseDateValues.year, month, day)
		this.date.setFullYear(year)
		this.isBC = isBC || year < 0; // Set isBC flag based on year or parameter

		// Oluşturulan tarih geçerli mi kontrol et
		if (isNaN(this.date.getTime())) {
			console.error("CustomDate: Invalid date created", {
				year,
				month,
				day,
				isBC
			})
			this.date = new Date(baseDateValues.year, baseDateValues.month, baseDateValues.day)
			this.isBC = false;
		}
	}

	// Getters
	getFullYear() {
		const year = this.date.getFullYear();
		return this.isBC && year > 0 ? -year : year;
	}

	getTime() {
		return this.date.getTime();
	}

	getMonth() {
		return this.date.getMonth()
	}

	getDate() {
		return this.date.getDate()
	}

	getHours() {
		return this.date.getHours()
	}

	getMinutes() {
		return this.date.getMinutes()
	}

	getSeconds() {
		return this.date.getSeconds()
	}

	getMilliseconds() {
		return this.date.getMilliseconds()
	}

	// Setters
	setFullYear(year) {
		this.date.setFullYear(year)
	}

	setMonth(month) {
		this.date.setMonth(month)
	}

	setDate(day) {
		this.date.setDate(day)
	}

	setHours(hours) {
		this.date.setHours(hours)
	}

	setMinutes(minutes) {
		this.date.setMinutes(minutes)
	}

	setSeconds(seconds) {
		this.date.setSeconds(seconds)
	}

	setMilliseconds(milliseconds) {
		this.date.setMilliseconds(milliseconds)
	}

	// Other methods
	toISOString() {
		return this.date.toISOString()
	}

	addDays(days) {
		if (typeof days === "number" && days % 1 !== 0) {
			// Herhangi bir ondalıklı sayı için
			const wholeDay = Math.floor(days) // Tam gün kısmı
			const fractionalHours = (days - wholeDay) * 24 // Saatlere çevir

			// Önce tam günleri ekle
			if (wholeDay !== 0) {
				this.date.setDate(this.date.getDate() + wholeDay)
			}

			// Sonra saatleri ekle
			this.date.setHours(this.date.getHours() + fractionalHours)
		} else {
			// Tam sayılar için normal işlem
			this.date.setDate(this.date.getDate() + days)
		}
		return this
	}

	addMonths(months) {
		this.date.setMonth(this.date.getMonth() + months)
		return this
	}

	addYears(years) {
		// MÖ/MS geçişlerini düzgün işleyen güvenli yıl ekleme
        const integerYears = Math.trunc(years);
        const fractionYears = years - integerYears;

		const currentYear = this.getFullYear() // Gerçek yıl (MÖ için negatif)
		const newYear = currentYear + integerYears

		this.date.setFullYear(newYear)

        // Kesirli yıl varsa gün olarak ekle (Yaklaşık 365.25 gün/yıl)
        if (fractionYears !== 0) {
            this.addDays(fractionYears * 365.25);
        }

		return this
	}

	toString() {
		// Daha detaylı ve doğru tarih gösterimi


		const y = this.date.getFullYear() < 0
			? `MÖ ${this.date.getFullYear()}`
			: `${this.date.getFullYear()}`
		if (this.date.getDate()===this.date.getDate() && y===y)
			return `${this.date.getDate()} ${monthNames[this.date.getMonth()]} ${y}`
		else
			return "error"
	}

	clone() {
		const newDate = new CustomDate(
			baseDateValues.year,
			this.date.getMonth(),
			this.date.getDate()
		)
		newDate.date.setFullYear(this.date.getFullYear())
		newDate.date.setHours(this.date.getHours())
		newDate.date.setMinutes(this.date.getMinutes())
		newDate.date.setSeconds(this.date.getSeconds())
		newDate.date.setMilliseconds(this.date.getMilliseconds())
		return newDate
	}

	// Statik metodlar
	static isFirstDayOfYear(date) {
		return date.getMonth() === 0 && date.getDate() === 1
	}

	static isFirstDayOfMonth(date) {
		return date.getDate() === 1
	}

	// Intervallere göre tarih ekleme metodu
	addIntervals(intervalCount, intervalType) {
		switch (intervalType) {
			case "6hours":
				return this.addDays(intervalCount * 0.25)
			case "day":
				return this.addDays(intervalCount)
			case "week":
				return this.addDays(intervalCount * 7)
			case "2weeks":
				return this.addDays(intervalCount * 14)
			case "month":
				return this.addMonths(intervalCount)
			case "3 Aylık":
			case "3months":
				return this.addMonths(intervalCount * 3)
			case "year":
				return this.addYears(intervalCount)
            case "2years":
                return this.addYears(intervalCount * 2)
            case "5years":
                return this.addYears(intervalCount * 5)
			case "10years":
			case "10year":
				return this.addYears(intervalCount * 10)
            case "20years":
                return this.addYears(intervalCount * 20)
            case "50years":
                return this.addYears(intervalCount * 50)
			case "100years":
			case "100year":
				return this.addYears(intervalCount * 100)
			case "1000years":
			case "1000year":
				return this.addYears(intervalCount * 1000)
			default:
				console.warn(
					`Bilinmeyen interval tipi: ${intervalType}, varsayılan 'day' kullanılıyor.`
				)
				return this.addDays(intervalCount)
		}
	}


	// Aydaki toplam gün sayısını hesapla
	getDaysInMonth() {
		const year = this.date.getFullYear()
		const month = this.date.getMonth()

		// Sonraki ayın 0. günü, bu ayın son günüdür
		return new Date(year, month + 1, 0).getDate()
	}

	isBetween(date1,date2) {
		 return (date1.getTime() < this.date.getTime()) && (this.date.getTime()< date2.getTime()) 
	}


}

export default CustomDate
